// Pure edition/filter rules; CommonJS permits tests without a browser or Babel.
const EDITIONS = Object.freeze([
  Object.freeze({year: 2014, id: "20140000-0000-4000-8000-000000000001"}),
  Object.freeze({year: 2022, id: "20220000-0000-4000-8000-000000000001"})
])
const DEFAULT_EDITION = EDITIONS[0].id

function resolveEdition(id) {
  return EDITIONS.some(edition => edition.id === id) ? id : DEFAULT_EDITION
}

function changeFilter(query, name, value) {
  const next = {...query, [name]: value || undefined}
  if (name === "standard_set") {
    for (const key of ["standard", "pattern"]) delete next[key]
  } else if (name === "subject" || name === "grade" || name === "standard") {
    delete next.pattern
    if (name !== "standard") delete next.standard
  }
  return next
}

function deParameters(entity, query = {}, language) {
  const allowed = entity === "expectations" ? ["standard", "pattern"]
    : entity === "subjects" ? ["standard_set"]
    : entity === "grades" ? ["subject", "standard_set"]
    : ["subject", "grade", "standard_set"]
  const result = {language}
  for (const key of allowed) if (query[key] !== undefined) result[key] = query[key]
  return result
}

function resolveItemEdition(item = {}) {
  return resolveEdition(item.standard_set)
}

function groupByEdition(items = []) {
  return EDITIONS.map(edition => ({
    ...edition,
    items: items.filter(item => resolveItemEdition(item) === edition.id)
  })).filter(group => group.items.length > 0)
}

module.exports = {EDITIONS, DEFAULT_EDITION, resolveEdition, resolveItemEdition, groupByEdition, changeFilter, deParameters}
